const getIP = () => {
  let { origin } = window.location;
  if (origin.includes("http://localhost")) {
    //REPLACE the hostname below to change which server GUI makes API calls to....

    // return "https://dev4.ngagecpaas.com";

   return "https://eand.ngagecpaas.com/";
  // return "http://cpaaspvg.comviva.com:32606";

    // return "https://eand.ngagecpaas.com";
     //return "https://dev1.ngagecpaas.com";
   // return ""; // proxied via CRA dev server to avoid CORS
  } else {
    return origin;
  }
};

export default getIP;
